
import api from "../../../api/api"

const typeIcons = {1: '📝',2: '⏰',3: '🗓️'};
const priorityDots = {1 :'🚨', 2 : '🟡', 3 : '🟢'}; //🔴

const statusColorClass = {
    1:"bg-charcoal",
    2:"bg-warning",
    3:"bg-orange",
    4:"bg-plum",
    5:"bg-magenta",
    6:"bg-success"
}


const statusBorderColorClass = {
    1:"border-charcoal",
    2:"border-warning",
    3:"border-orange",
    4:"border-purple",
    5:"border-magenta",
    6:"border-success"
}

const statusTableColorClass = {
    1:"table-charcoal",
    2:"table-warning",
    3:"table-orange",
    4:"table-plum",
    5:"table-magenta",
    6:"table-success"
}

const getList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/task").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getArchivedList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/task/archived/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const essTaskServices = {
    typeIcons,
    priorityDots,
    statusColorClass,
    statusBorderColorClass,
    statusTableColorClass,
    getList,
    getArchivedList,
}
export default essTaskServices;